<app-swiper-unit
  [data]="providerList"
  title="Providers"
  titleIcon="assets/images/home/bear_taps.png"
  [isProvider]="true"
  [hasFavorite]="false"
  [hasHover]="false"
  [hasMask]="false"
  [ratio]="1 / 0.34"
  [titleHref]="'/' + providerHref"
  [imgCarouselConfig]="imgCarouselConfig"
  (clickItem)="clickProviderItem($event)"
  (clickTitle)="clickProviderTitle()"
  [showArrowGroupH5]="true"
></app-swiper-unit>
